// Protocol Buffers for Certification Authority Service
// 
// Source: java_inventory.md Section 13 (CertificationAuthorityGrpcService.java)

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/marketplace/certification.proto (package guardianai.v1.marketplace, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/marketplace/certification.proto.
 */
export const file_guardianai_v1_marketplace_certification: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.marketplace.CertificationRequest
 */
export type CertificationRequest = Message<"guardianai.v1.marketplace.CertificationRequest"> & {
  /**
   * @generated from field: string applicant_id = 1;
   */
  applicantId: string;

  /**
   * @generated from field: string certification_type = 2;
   */
  certificationType: string;

  /**
   * @generated from field: string level = 3;
   */
  level: string;

  /**
   * @generated from field: string justification = 4;
   */
  justification: string;
};

/**
 * @generated from message guardianai.v1.marketplace.CertificationRequest
 */
export type CertificationRequestJson = {
  /**
   * @generated from field: string applicant_id = 1;
   */
  applicantId?: string;

  /**
   * @generated from field: string certification_type = 2;
   */
  certificationType?: string;

  /**
   * @generated from field: string level = 3;
   */
  level?: string;

  /**
   * @generated from field: string justification = 4;
   */
  justification?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.CertificationRequest.
 * Use `create(CertificationRequestSchema)` to create a new message.
 */
export const CertificationRequestSchema: GenMessage<CertificationRequest, {jsonType: CertificationRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 0);

/**
 * @generated from message guardianai.v1.marketplace.CertificationResponse
 */
export type CertificationResponse = Message<"guardianai.v1.marketplace.CertificationResponse"> & {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId: string;

  /**
   * @generated from field: string applicant_id = 2;
   */
  applicantId: string;

  /**
   * @generated from field: string certification_type = 3;
   */
  certificationType: string;

  /**
   * @generated from field: string level = 4;
   */
  level: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: int64 requested_at = 6;
   */
  requestedAt: bigint;

  /**
   * @generated from field: int64 approved_at = 7;
   */
  approvedAt: bigint;

  /**
   * @generated from field: int64 expires_at = 8;
   */
  expiresAt: bigint;
};

/**
 * @generated from message guardianai.v1.marketplace.CertificationResponse
 */
export type CertificationResponseJson = {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId?: string;

  /**
   * @generated from field: string applicant_id = 2;
   */
  applicantId?: string;

  /**
   * @generated from field: string certification_type = 3;
   */
  certificationType?: string;

  /**
   * @generated from field: string level = 4;
   */
  level?: string;

  /**
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: int64 requested_at = 6;
   */
  requestedAt?: string;

  /**
   * @generated from field: int64 approved_at = 7;
   */
  approvedAt?: string;

  /**
   * @generated from field: int64 expires_at = 8;
   */
  expiresAt?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.CertificationResponse.
 * Use `create(CertificationResponseSchema)` to create a new message.
 */
export const CertificationResponseSchema: GenMessage<CertificationResponse, {jsonType: CertificationResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 1);

/**
 * @generated from message guardianai.v1.marketplace.GetStatusRequest
 */
export type GetStatusRequest = Message<"guardianai.v1.marketplace.GetStatusRequest"> & {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId: string;
};

/**
 * @generated from message guardianai.v1.marketplace.GetStatusRequest
 */
export type GetStatusRequestJson = {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.GetStatusRequest.
 * Use `create(GetStatusRequestSchema)` to create a new message.
 */
export const GetStatusRequestSchema: GenMessage<GetStatusRequest, {jsonType: GetStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 2);

/**
 * @generated from message guardianai.v1.marketplace.ApproveRequest
 */
export type ApproveRequest = Message<"guardianai.v1.marketplace.ApproveRequest"> & {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId: string;

  /**
   * @generated from field: string approver_id = 2;
   */
  approverId: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes: string;
};

/**
 * @generated from message guardianai.v1.marketplace.ApproveRequest
 */
export type ApproveRequestJson = {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId?: string;

  /**
   * @generated from field: string approver_id = 2;
   */
  approverId?: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.ApproveRequest.
 * Use `create(ApproveRequestSchema)` to create a new message.
 */
export const ApproveRequestSchema: GenMessage<ApproveRequest, {jsonType: ApproveRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 3);

/**
 * @generated from message guardianai.v1.marketplace.RejectRequest
 */
export type RejectRequest = Message<"guardianai.v1.marketplace.RejectRequest"> & {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId: string;

  /**
   * @generated from field: string rejector_id = 2;
   */
  rejectorId: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.marketplace.RejectRequest
 */
export type RejectRequestJson = {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId?: string;

  /**
   * @generated from field: string rejector_id = 2;
   */
  rejectorId?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.RejectRequest.
 * Use `create(RejectRequestSchema)` to create a new message.
 */
export const RejectRequestSchema: GenMessage<RejectRequest, {jsonType: RejectRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 4);

/**
 * @generated from message guardianai.v1.marketplace.RevokeRequest
 */
export type RevokeRequest = Message<"guardianai.v1.marketplace.RevokeRequest"> & {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.marketplace.RevokeRequest
 */
export type RevokeRequestJson = {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId?: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.RevokeRequest.
 * Use `create(RevokeRequestSchema)` to create a new message.
 */
export const RevokeRequestSchema: GenMessage<RevokeRequest, {jsonType: RevokeRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 5);

/**
 * @generated from message guardianai.v1.marketplace.RevokeResponse
 */
export type RevokeResponse = Message<"guardianai.v1.marketplace.RevokeResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.marketplace.RevokeResponse
 */
export type RevokeResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.RevokeResponse.
 * Use `create(RevokeResponseSchema)` to create a new message.
 */
export const RevokeResponseSchema: GenMessage<RevokeResponse, {jsonType: RevokeResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 6);

/**
 * @generated from message guardianai.v1.marketplace.RenewRequest
 */
export type RenewRequest = Message<"guardianai.v1.marketplace.RenewRequest"> & {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId: string;
};

/**
 * @generated from message guardianai.v1.marketplace.RenewRequest
 */
export type RenewRequestJson = {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.RenewRequest.
 * Use `create(RenewRequestSchema)` to create a new message.
 */
export const RenewRequestSchema: GenMessage<RenewRequest, {jsonType: RenewRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 7);

/**
 * @generated from message guardianai.v1.marketplace.GetCertificateRequest
 */
export type GetCertificateRequest = Message<"guardianai.v1.marketplace.GetCertificateRequest"> & {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId: string;
};

/**
 * @generated from message guardianai.v1.marketplace.GetCertificateRequest
 */
export type GetCertificateRequestJson = {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.GetCertificateRequest.
 * Use `create(GetCertificateRequestSchema)` to create a new message.
 */
export const GetCertificateRequestSchema: GenMessage<GetCertificateRequest, {jsonType: GetCertificateRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 8);

/**
 * @generated from message guardianai.v1.marketplace.CertificateResponse
 */
export type CertificateResponse = Message<"guardianai.v1.marketplace.CertificateResponse"> & {
  /**
   * @generated from field: string certificate_id = 1;
   */
  certificateId: string;

  /**
   * @generated from field: bytes certificate_data = 2;
   */
  certificateData: Uint8Array;

  /**
   * @generated from field: string format = 3;
   */
  format: string;

  /**
   * @generated from field: int64 issued_at = 4;
   */
  issuedAt: bigint;
};

/**
 * @generated from message guardianai.v1.marketplace.CertificateResponse
 */
export type CertificateResponseJson = {
  /**
   * @generated from field: string certificate_id = 1;
   */
  certificateId?: string;

  /**
   * @generated from field: bytes certificate_data = 2;
   */
  certificateData?: string;

  /**
   * @generated from field: string format = 3;
   */
  format?: string;

  /**
   * @generated from field: int64 issued_at = 4;
   */
  issuedAt?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.CertificateResponse.
 * Use `create(CertificateResponseSchema)` to create a new message.
 */
export const CertificateResponseSchema: GenMessage<CertificateResponse, {jsonType: CertificateResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 9);

/**
 * @generated from message guardianai.v1.marketplace.VerifyCertificateRequest
 */
export type VerifyCertificateRequest = Message<"guardianai.v1.marketplace.VerifyCertificateRequest"> & {
  /**
   * @generated from field: bytes certificate_data = 1;
   */
  certificateData: Uint8Array;
};

/**
 * @generated from message guardianai.v1.marketplace.VerifyCertificateRequest
 */
export type VerifyCertificateRequestJson = {
  /**
   * @generated from field: bytes certificate_data = 1;
   */
  certificateData?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.VerifyCertificateRequest.
 * Use `create(VerifyCertificateRequestSchema)` to create a new message.
 */
export const VerifyCertificateRequestSchema: GenMessage<VerifyCertificateRequest, {jsonType: VerifyCertificateRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 10);

/**
 * @generated from message guardianai.v1.marketplace.VerificationResponse
 */
export type VerificationResponse = Message<"guardianai.v1.marketplace.VerificationResponse"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: string holder_id = 2;
   */
  holderId: string;

  /**
   * @generated from field: string certification_type = 3;
   */
  certificationType: string;

  /**
   * @generated from field: string level = 4;
   */
  level: string;

  /**
   * @generated from field: int64 expires_at = 5;
   */
  expiresAt: bigint;

  /**
   * @generated from field: string message = 6;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.marketplace.VerificationResponse
 */
export type VerificationResponseJson = {
  /**
   * @generated from field: bool valid = 1;
   */
  valid?: boolean;

  /**
   * @generated from field: string holder_id = 2;
   */
  holderId?: string;

  /**
   * @generated from field: string certification_type = 3;
   */
  certificationType?: string;

  /**
   * @generated from field: string level = 4;
   */
  level?: string;

  /**
   * @generated from field: int64 expires_at = 5;
   */
  expiresAt?: string;

  /**
   * @generated from field: string message = 6;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.VerificationResponse.
 * Use `create(VerificationResponseSchema)` to create a new message.
 */
export const VerificationResponseSchema: GenMessage<VerificationResponse, {jsonType: VerificationResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 11);

/**
 * @generated from message guardianai.v1.marketplace.ListCertificationsRequest
 */
export type ListCertificationsRequest = Message<"guardianai.v1.marketplace.ListCertificationsRequest"> & {
  /**
   * @generated from field: string applicant_id = 1;
   */
  applicantId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string certification_type = 3;
   */
  certificationType: string;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.marketplace.ListCertificationsRequest
 */
export type ListCertificationsRequestJson = {
  /**
   * @generated from field: string applicant_id = 1;
   */
  applicantId?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: string certification_type = 3;
   */
  certificationType?: string;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.marketplace.ListCertificationsRequest.
 * Use `create(ListCertificationsRequestSchema)` to create a new message.
 */
export const ListCertificationsRequestSchema: GenMessage<ListCertificationsRequest, {jsonType: ListCertificationsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 12);

/**
 * @generated from message guardianai.v1.marketplace.ListCertificationsResponse
 */
export type ListCertificationsResponse = Message<"guardianai.v1.marketplace.ListCertificationsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.CertificationResponse certifications = 1;
   */
  certifications: CertificationResponse[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.marketplace.ListCertificationsResponse
 */
export type ListCertificationsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.CertificationResponse certifications = 1;
   */
  certifications?: CertificationResponseJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.marketplace.ListCertificationsResponse.
 * Use `create(ListCertificationsResponseSchema)` to create a new message.
 */
export const ListCertificationsResponseSchema: GenMessage<ListCertificationsResponse, {jsonType: ListCertificationsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 13);

/**
 * @generated from message guardianai.v1.marketplace.GetRequirementsRequest
 */
export type GetRequirementsRequest = Message<"guardianai.v1.marketplace.GetRequirementsRequest"> & {
  /**
   * @generated from field: string certification_type = 1;
   */
  certificationType: string;

  /**
   * @generated from field: string level = 2;
   */
  level: string;
};

/**
 * @generated from message guardianai.v1.marketplace.GetRequirementsRequest
 */
export type GetRequirementsRequestJson = {
  /**
   * @generated from field: string certification_type = 1;
   */
  certificationType?: string;

  /**
   * @generated from field: string level = 2;
   */
  level?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.GetRequirementsRequest.
 * Use `create(GetRequirementsRequestSchema)` to create a new message.
 */
export const GetRequirementsRequestSchema: GenMessage<GetRequirementsRequest, {jsonType: GetRequirementsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 14);

/**
 * @generated from message guardianai.v1.marketplace.RequirementsResponse
 */
export type RequirementsResponse = Message<"guardianai.v1.marketplace.RequirementsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.Requirement requirements = 1;
   */
  requirements: Requirement[];
};

/**
 * @generated from message guardianai.v1.marketplace.RequirementsResponse
 */
export type RequirementsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.Requirement requirements = 1;
   */
  requirements?: RequirementJson[];
};

/**
 * Describes the message guardianai.v1.marketplace.RequirementsResponse.
 * Use `create(RequirementsResponseSchema)` to create a new message.
 */
export const RequirementsResponseSchema: GenMessage<RequirementsResponse, {jsonType: RequirementsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 15);

/**
 * @generated from message guardianai.v1.marketplace.Requirement
 */
export type Requirement = Message<"guardianai.v1.marketplace.Requirement"> & {
  /**
   * @generated from field: string requirement_id = 1;
   */
  requirementId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: bool mandatory = 4;
   */
  mandatory: boolean;
};

/**
 * @generated from message guardianai.v1.marketplace.Requirement
 */
export type RequirementJson = {
  /**
   * @generated from field: string requirement_id = 1;
   */
  requirementId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: bool mandatory = 4;
   */
  mandatory?: boolean;
};

/**
 * Describes the message guardianai.v1.marketplace.Requirement.
 * Use `create(RequirementSchema)` to create a new message.
 */
export const RequirementSchema: GenMessage<Requirement, {jsonType: RequirementJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 16);

/**
 * @generated from message guardianai.v1.marketplace.SubmitDocumentRequest
 */
export type SubmitDocumentRequest = Message<"guardianai.v1.marketplace.SubmitDocumentRequest"> & {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId: string;

  /**
   * @generated from field: string document_type = 2;
   */
  documentType: string;

  /**
   * @generated from field: bytes document_data = 3;
   */
  documentData: Uint8Array;

  /**
   * @generated from field: string filename = 4;
   */
  filename: string;
};

/**
 * @generated from message guardianai.v1.marketplace.SubmitDocumentRequest
 */
export type SubmitDocumentRequestJson = {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId?: string;

  /**
   * @generated from field: string document_type = 2;
   */
  documentType?: string;

  /**
   * @generated from field: bytes document_data = 3;
   */
  documentData?: string;

  /**
   * @generated from field: string filename = 4;
   */
  filename?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.SubmitDocumentRequest.
 * Use `create(SubmitDocumentRequestSchema)` to create a new message.
 */
export const SubmitDocumentRequestSchema: GenMessage<SubmitDocumentRequest, {jsonType: SubmitDocumentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 17);

/**
 * @generated from message guardianai.v1.marketplace.DocumentResponse
 */
export type DocumentResponse = Message<"guardianai.v1.marketplace.DocumentResponse"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: bool uploaded = 2;
   */
  uploaded: boolean;
};

/**
 * @generated from message guardianai.v1.marketplace.DocumentResponse
 */
export type DocumentResponseJson = {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId?: string;

  /**
   * @generated from field: bool uploaded = 2;
   */
  uploaded?: boolean;
};

/**
 * Describes the message guardianai.v1.marketplace.DocumentResponse.
 * Use `create(DocumentResponseSchema)` to create a new message.
 */
export const DocumentResponseSchema: GenMessage<DocumentResponse, {jsonType: DocumentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 18);

/**
 * @generated from message guardianai.v1.marketplace.GetDocumentsRequest
 */
export type GetDocumentsRequest = Message<"guardianai.v1.marketplace.GetDocumentsRequest"> & {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId: string;
};

/**
 * @generated from message guardianai.v1.marketplace.GetDocumentsRequest
 */
export type GetDocumentsRequestJson = {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.GetDocumentsRequest.
 * Use `create(GetDocumentsRequestSchema)` to create a new message.
 */
export const GetDocumentsRequestSchema: GenMessage<GetDocumentsRequest, {jsonType: GetDocumentsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 19);

/**
 * @generated from message guardianai.v1.marketplace.DocumentsResponse
 */
export type DocumentsResponse = Message<"guardianai.v1.marketplace.DocumentsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.SubmittedDocument documents = 1;
   */
  documents: SubmittedDocument[];
};

/**
 * @generated from message guardianai.v1.marketplace.DocumentsResponse
 */
export type DocumentsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.SubmittedDocument documents = 1;
   */
  documents?: SubmittedDocumentJson[];
};

/**
 * Describes the message guardianai.v1.marketplace.DocumentsResponse.
 * Use `create(DocumentsResponseSchema)` to create a new message.
 */
export const DocumentsResponseSchema: GenMessage<DocumentsResponse, {jsonType: DocumentsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 20);

/**
 * @generated from message guardianai.v1.marketplace.SubmittedDocument
 */
export type SubmittedDocument = Message<"guardianai.v1.marketplace.SubmittedDocument"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: string document_type = 2;
   */
  documentType: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: int64 submitted_at = 5;
   */
  submittedAt: bigint;
};

/**
 * @generated from message guardianai.v1.marketplace.SubmittedDocument
 */
export type SubmittedDocumentJson = {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId?: string;

  /**
   * @generated from field: string document_type = 2;
   */
  documentType?: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename?: string;

  /**
   * @generated from field: string status = 4;
   */
  status?: string;

  /**
   * @generated from field: int64 submitted_at = 5;
   */
  submittedAt?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.SubmittedDocument.
 * Use `create(SubmittedDocumentSchema)` to create a new message.
 */
export const SubmittedDocumentSchema: GenMessage<SubmittedDocument, {jsonType: SubmittedDocumentJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 21);

/**
 * @generated from message guardianai.v1.marketplace.ScheduleExamRequest
 */
export type ScheduleExamRequest = Message<"guardianai.v1.marketplace.ScheduleExamRequest"> & {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId: string;

  /**
   * @generated from field: int64 preferred_time = 2;
   */
  preferredTime: bigint;
};

/**
 * @generated from message guardianai.v1.marketplace.ScheduleExamRequest
 */
export type ScheduleExamRequestJson = {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId?: string;

  /**
   * @generated from field: int64 preferred_time = 2;
   */
  preferredTime?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.ScheduleExamRequest.
 * Use `create(ScheduleExamRequestSchema)` to create a new message.
 */
export const ScheduleExamRequestSchema: GenMessage<ScheduleExamRequest, {jsonType: ScheduleExamRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 22);

/**
 * @generated from message guardianai.v1.marketplace.ExamResponse
 */
export type ExamResponse = Message<"guardianai.v1.marketplace.ExamResponse"> & {
  /**
   * @generated from field: string exam_id = 1;
   */
  examId: string;

  /**
   * @generated from field: int64 scheduled_at = 2;
   */
  scheduledAt: bigint;

  /**
   * @generated from field: string location = 3;
   */
  location: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;
};

/**
 * @generated from message guardianai.v1.marketplace.ExamResponse
 */
export type ExamResponseJson = {
  /**
   * @generated from field: string exam_id = 1;
   */
  examId?: string;

  /**
   * @generated from field: int64 scheduled_at = 2;
   */
  scheduledAt?: string;

  /**
   * @generated from field: string location = 3;
   */
  location?: string;

  /**
   * @generated from field: string status = 4;
   */
  status?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.ExamResponse.
 * Use `create(ExamResponseSchema)` to create a new message.
 */
export const ExamResponseSchema: GenMessage<ExamResponse, {jsonType: ExamResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 23);

/**
 * @generated from message guardianai.v1.marketplace.ExamResultsRequest
 */
export type ExamResultsRequest = Message<"guardianai.v1.marketplace.ExamResultsRequest"> & {
  /**
   * @generated from field: string exam_id = 1;
   */
  examId: string;

  /**
   * @generated from field: int32 score = 2;
   */
  score: number;

  /**
   * @generated from field: bool passed = 3;
   */
  passed: boolean;
};

/**
 * @generated from message guardianai.v1.marketplace.ExamResultsRequest
 */
export type ExamResultsRequestJson = {
  /**
   * @generated from field: string exam_id = 1;
   */
  examId?: string;

  /**
   * @generated from field: int32 score = 2;
   */
  score?: number;

  /**
   * @generated from field: bool passed = 3;
   */
  passed?: boolean;
};

/**
 * Describes the message guardianai.v1.marketplace.ExamResultsRequest.
 * Use `create(ExamResultsRequestSchema)` to create a new message.
 */
export const ExamResultsRequestSchema: GenMessage<ExamResultsRequest, {jsonType: ExamResultsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 24);

/**
 * @generated from message guardianai.v1.marketplace.ExamResultsResponse
 */
export type ExamResultsResponse = Message<"guardianai.v1.marketplace.ExamResultsResponse"> & {
  /**
   * @generated from field: bool recorded = 1;
   */
  recorded: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.marketplace.ExamResultsResponse
 */
export type ExamResultsResponseJson = {
  /**
   * @generated from field: bool recorded = 1;
   */
  recorded?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.ExamResultsResponse.
 * Use `create(ExamResultsResponseSchema)` to create a new message.
 */
export const ExamResultsResponseSchema: GenMessage<ExamResultsResponse, {jsonType: ExamResultsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 25);

/**
 * @generated from message guardianai.v1.marketplace.GetExamScheduleRequest
 */
export type GetExamScheduleRequest = Message<"guardianai.v1.marketplace.GetExamScheduleRequest"> & {
  /**
   * @generated from field: string applicant_id = 1;
   */
  applicantId: string;
};

/**
 * @generated from message guardianai.v1.marketplace.GetExamScheduleRequest
 */
export type GetExamScheduleRequestJson = {
  /**
   * @generated from field: string applicant_id = 1;
   */
  applicantId?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.GetExamScheduleRequest.
 * Use `create(GetExamScheduleRequestSchema)` to create a new message.
 */
export const GetExamScheduleRequestSchema: GenMessage<GetExamScheduleRequest, {jsonType: GetExamScheduleRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 26);

/**
 * @generated from message guardianai.v1.marketplace.ExamScheduleResponse
 */
export type ExamScheduleResponse = Message<"guardianai.v1.marketplace.ExamScheduleResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.ExamResponse exams = 1;
   */
  exams: ExamResponse[];
};

/**
 * @generated from message guardianai.v1.marketplace.ExamScheduleResponse
 */
export type ExamScheduleResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.ExamResponse exams = 1;
   */
  exams?: ExamResponseJson[];
};

/**
 * Describes the message guardianai.v1.marketplace.ExamScheduleResponse.
 * Use `create(ExamScheduleResponseSchema)` to create a new message.
 */
export const ExamScheduleResponseSchema: GenMessage<ExamScheduleResponse, {jsonType: ExamScheduleResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 27);

/**
 * @generated from message guardianai.v1.marketplace.GetCertAnalyticsRequest
 */
export type GetCertAnalyticsRequest = Message<"guardianai.v1.marketplace.GetCertAnalyticsRequest"> & {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime: bigint;
};

/**
 * @generated from message guardianai.v1.marketplace.GetCertAnalyticsRequest
 */
export type GetCertAnalyticsRequestJson = {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.GetCertAnalyticsRequest.
 * Use `create(GetCertAnalyticsRequestSchema)` to create a new message.
 */
export const GetCertAnalyticsRequestSchema: GenMessage<GetCertAnalyticsRequest, {jsonType: GetCertAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 28);

/**
 * @generated from message guardianai.v1.marketplace.CertAnalyticsResponse
 */
export type CertAnalyticsResponse = Message<"guardianai.v1.marketplace.CertAnalyticsResponse"> & {
  /**
   * @generated from field: int32 total_requests = 1;
   */
  totalRequests: number;

  /**
   * @generated from field: int32 approved = 2;
   */
  approved: number;

  /**
   * @generated from field: int32 rejected = 3;
   */
  rejected: number;

  /**
   * @generated from field: int32 pending = 4;
   */
  pending: number;

  /**
   * @generated from field: double approval_rate = 5;
   */
  approvalRate: number;
};

/**
 * @generated from message guardianai.v1.marketplace.CertAnalyticsResponse
 */
export type CertAnalyticsResponseJson = {
  /**
   * @generated from field: int32 total_requests = 1;
   */
  totalRequests?: number;

  /**
   * @generated from field: int32 approved = 2;
   */
  approved?: number;

  /**
   * @generated from field: int32 rejected = 3;
   */
  rejected?: number;

  /**
   * @generated from field: int32 pending = 4;
   */
  pending?: number;

  /**
   * @generated from field: double approval_rate = 5;
   */
  approvalRate?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.marketplace.CertAnalyticsResponse.
 * Use `create(CertAnalyticsResponseSchema)` to create a new message.
 */
export const CertAnalyticsResponseSchema: GenMessage<CertAnalyticsResponse, {jsonType: CertAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 29);

/**
 * @generated from message guardianai.v1.marketplace.UpdateLevelRequest
 */
export type UpdateLevelRequest = Message<"guardianai.v1.marketplace.UpdateLevelRequest"> & {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId: string;

  /**
   * @generated from field: string new_level = 2;
   */
  newLevel: string;
};

/**
 * @generated from message guardianai.v1.marketplace.UpdateLevelRequest
 */
export type UpdateLevelRequestJson = {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId?: string;

  /**
   * @generated from field: string new_level = 2;
   */
  newLevel?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.UpdateLevelRequest.
 * Use `create(UpdateLevelRequestSchema)` to create a new message.
 */
export const UpdateLevelRequestSchema: GenMessage<UpdateLevelRequest, {jsonType: UpdateLevelRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_certification, 30);

/**
 * Certification Authority Service - Investigator and agent certification
 *
 * @generated from service guardianai.v1.marketplace.CertificationAuthorityService
 */
export const CertificationAuthorityService: GenService<{
  /**
   * Request certification
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.RequestCertification
   */
  requestCertification: {
    methodKind: "unary";
    input: typeof CertificationRequestSchema;
    output: typeof CertificationResponseSchema;
  },
  /**
   * Get certification status
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.GetCertificationStatus
   */
  getCertificationStatus: {
    methodKind: "unary";
    input: typeof GetStatusRequestSchema;
    output: typeof CertificationResponseSchema;
  },
  /**
   * Approve certification
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.ApproveCertification
   */
  approveCertification: {
    methodKind: "unary";
    input: typeof ApproveRequestSchema;
    output: typeof CertificationResponseSchema;
  },
  /**
   * Reject certification
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.RejectCertification
   */
  rejectCertification: {
    methodKind: "unary";
    input: typeof RejectRequestSchema;
    output: typeof CertificationResponseSchema;
  },
  /**
   * Revoke certification
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.RevokeCertification
   */
  revokeCertification: {
    methodKind: "unary";
    input: typeof RevokeRequestSchema;
    output: typeof RevokeResponseSchema;
  },
  /**
   * Renew certification
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.RenewCertification
   */
  renewCertification: {
    methodKind: "unary";
    input: typeof RenewRequestSchema;
    output: typeof CertificationResponseSchema;
  },
  /**
   * Get certificate
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.GetCertificate
   */
  getCertificate: {
    methodKind: "unary";
    input: typeof GetCertificateRequestSchema;
    output: typeof CertificateResponseSchema;
  },
  /**
   * Verify certificate
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.VerifyCertificate
   */
  verifyCertificate: {
    methodKind: "unary";
    input: typeof VerifyCertificateRequestSchema;
    output: typeof VerificationResponseSchema;
  },
  /**
   * List certifications
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.ListCertifications
   */
  listCertifications: {
    methodKind: "unary";
    input: typeof ListCertificationsRequestSchema;
    output: typeof ListCertificationsResponseSchema;
  },
  /**
   * Get certification requirements
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.GetRequirements
   */
  getRequirements: {
    methodKind: "unary";
    input: typeof GetRequirementsRequestSchema;
    output: typeof RequirementsResponseSchema;
  },
  /**
   * Submit verification document
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.SubmitDocument
   */
  submitDocument: {
    methodKind: "unary";
    input: typeof SubmitDocumentRequestSchema;
    output: typeof DocumentResponseSchema;
  },
  /**
   * Get submitted documents
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.GetDocuments
   */
  getDocuments: {
    methodKind: "unary";
    input: typeof GetDocumentsRequestSchema;
    output: typeof DocumentsResponseSchema;
  },
  /**
   * Schedule exam
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.ScheduleExam
   */
  scheduleExam: {
    methodKind: "unary";
    input: typeof ScheduleExamRequestSchema;
    output: typeof ExamResponseSchema;
  },
  /**
   * Submit exam results
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.SubmitExamResults
   */
  submitExamResults: {
    methodKind: "unary";
    input: typeof ExamResultsRequestSchema;
    output: typeof ExamResultsResponseSchema;
  },
  /**
   * Get exam schedule
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.GetExamSchedule
   */
  getExamSchedule: {
    methodKind: "unary";
    input: typeof GetExamScheduleRequestSchema;
    output: typeof ExamScheduleResponseSchema;
  },
  /**
   * Get certification analytics
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.GetAnalytics
   */
  getAnalytics: {
    methodKind: "unary";
    input: typeof GetCertAnalyticsRequestSchema;
    output: typeof CertAnalyticsResponseSchema;
  },
  /**
   * Update certification level
   *
   * @generated from rpc guardianai.v1.marketplace.CertificationAuthorityService.UpdateLevel
   */
  updateLevel: {
    methodKind: "unary";
    input: typeof UpdateLevelRequestSchema;
    output: typeof CertificationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_marketplace_certification, 0);

